import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/mediabook/mediabook/src/templates/Standalone.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Science & Letters (CORE)`}</h1>
    <p>{`The Science & Letters (CORE) curriculum comprises nine categories: Effective Communication 1,
Effective Communication 2, Quantitative Literacy & Social Issues, Civic Knowledge and Engagement,
Artistic and Creative Expression, Science for Global Citizens, An Examined Life, Social Sciences:
Understanding Human Behavior, and Purpose and Meaning.`}</p>
    <p>{`Make School embraces diversity and encourages students to bring their informed perspectives to the
learning environment. As such, Make School’s S&L curriculum allows for various worldviews to be
present in the classroom and extends the ability for students to engage in the free expression of
ideas in their search for truth. Therefore, faculty and students are protected by
`}<a parentName="p" {...{
        "href": "../academic-and-educational-program-information/academic-freedom"
      }}>{`Academic Freedom`}</a>{` in all Science
and Letters courses.`}</p>
    <p>{`Science and Letters classes available for registration vary by term. The course descriptions
included are courses that have been previously been offered and may be offered during the 2021-2022
school year.`}</p>
    <ol>
      <li parentName="ol">{`Effective Communication 1`}</li>
    </ol>
    <p><strong parentName="p">{`EC1 - Effective Communication 1: Verbal and Visual Literacies (EC 1000) `}<em parentName="strong">{`4 Credits`}</em></strong></p>
    <p><em parentName="p">{`Prerequisites: None`}</em></p>
    <p>{`Courses in EC1 are designed to advance the following skills:`}</p>
    <ul>
      <li parentName="ul">{`Demonstrate the processes and products of critical reading, thinking, speaking, and writing;`}</li>
      <li parentName="ul">{`Analyze a range of texts and media (oral, visual, written, and performative) across disciplines
and across a range of rhetorical modes;`}</li>
      <li parentName="ul">{`Create effective written texts and oral presentations appropriate to topic, purpose and audience;`}</li>
      <li parentName="ul">{`Comprehend how communication shapes and is shaped by difference (including but not limited to
categories such as race, gender, sexuality, age and class);`}</li>
      <li parentName="ul">{`Retrieve, interpret, and apply source material; use proper citation and documentation.`}</li>
    </ul>
    <p><strong parentName="p">{`ENGL 1004: Expository Writing`}</strong></p>
    <p><em parentName="p">{`Prerequisites: None`}</em></p>
    <p>{`Students will engage in writing of university-level expository essays across rhetorical modes.
Emphasis on critical reading, and thinking, summary, analysis, synthesis, and research. Can be
substituted for EC 1000.`}</p>
    <ol {...{
      "start": 2
    }}>
      <li parentName="ol">{`Effective Communication 2`}</li>
    </ol>
    <p><strong parentName="p">{`EC2 - Effective Communication 2: Rhetoric and Research (EC 2000) `}<em parentName="strong">{`4 Credits`}</em></strong></p>
    <p><em parentName="p">{`Prerequisites: EC1`}</em></p>
    <p>{`Courses in EC2 are designed to advance the following skills:`}</p>
    <ul>
      <li parentName="ul">{`Demonstrate advanced critical thinking through such methods as summary, evaluation, synthesis, and
integration of research;`}</li>
      <li parentName="ul">{`Create effective, original, and argumentative rhetoric across media (oral, visual, and written)
appropriate to topic, purpose, and audience; topics and issues may include - problem solving,
civic engagement, and/or positing policy or social change;`}</li>
      <li parentName="ul">{`Apply understanding of how communication shapes and is shaped by difference (including but not
limited to categories such as race, gender, sexuality, age and class) and reflect on one’s own
place in a broader social context;`}</li>
      <li parentName="ul">{`Evaluate source material, synthesize new concepts, and apply deduction, induction, and/or logic
for advanced argumentative research purposes; use proper citation and documentation.`}</li>
    </ul>
    <ol {...{
      "start": 3
    }}>
      <li parentName="ol">{`Quantitative Literacy & Social Issues`}</li>
    </ol>
    <p><strong parentName="p">{`QL 1.1 - Quantitative Literacy and Social Issues (MATH 1450) `}<em parentName="strong">{`4 Credits`}</em></strong></p>
    <p><em parentName="p">{`Prerequisites: None`}</em></p>
    <p>{`Courses in QL are designed to advance the following skills:`}</p>
    <ul>
      <li parentName="ul">{`Develop capacities of quantitative reasoning to interpret, analyze, apply, and explain data
(information) presented in mathematical forms;`}</li>
      <li parentName="ul">{`Recognize and evaluate assumptions in estimation, modeling, and data analysis;`}</li>
      <li parentName="ul">{`Calculate mathematical problems, and communicate quantitative evidence in support of an argument;`}</li>
      <li parentName="ul">{`Apply quantitative reasoning skills using data analysis, probability, and statistics through
examples related to current world debates, inquiries, and problems;`}</li>
      <li parentName="ul">{`Gain and act with confidence to work through problems using quantitative reasoning.`}</li>
    </ul>
    <ol {...{
      "start": 4
    }}>
      <li parentName="ol">{`Civic Knowledge and Engagement`}</li>
    </ol>
    <p><strong parentName="p">{`CKE - CIVIC KNOWLEDGE & ENGAGEMENT`}</strong></p>
    <p><em parentName="p">{`Prerequisites: None`}</em></p>
    <p>{`Courses in CKE are designed to advance the following skills:`}</p>
    <ul>
      <li parentName="ul">{`Identify and analyze no less than three of the following content areas: political structures,
social systems, cultural trends, and/or historical change over time in the U.S. and/or other
countries.`}</li>
      <li parentName="ul">{`Critically analyze a pressing political, social, or environmental issue using multiple sources of
information. This analysis includes evaluating evidence through the interpretation of primary
sources to develop informed arguments about historical and/or contemporary issues and/or drawing
on community-based perspectives and experiences.`}</li>
      <li parentName="ul">{`Engage with local and local and/or global communities to build civic knowledge and skills, and
reflect critically on their roles and responsibilities as members of diverse communities and
societies.`}</li>
    </ul>
    <p><strong parentName="p">{`HCS 3131: Technology and Equity`}<em parentName="strong">{` 4 credits`}</em></strong></p>
    <p><em parentName="p">{`Prerequisites: None`}</em></p>
    <p>{`This course will investigate the relevance of gender, race and sexuality to understanding equity in
technology and the development of new technologies. We will consider a range of questions including:
What are some barriers in equity in Computer Science education? And how does an organization promote
or impede inequality? In addition, this course will utilize methodologies which promote engagement
with local communities to enhance civic knowledge and improve student civic skills.`}</p>
    <p><strong parentName="p">{`ENGL 3051: Latin American Literature `}<em parentName="strong">{`4 credits`}</em></strong></p>
    <p><em parentName="p">{`Prerequisites: None`}</em></p>
    <p>{`Study of major works and movements of Latin arts. The materials for this course are drawn from
across or within major geographical regions of Latin America and are focused on specific literary
periods varying from pre-contact indigenous works to 21st century postmodernism; they cover a wide
spectrum of prose, poetry, and, at times, narrative film that exemplifies national and regional
differences. Works and writers may include "Popol Vuh," "Quetzalcoatl," Garcia Marquez, Allende,
Borges, Neruda, and Paz.`}</p>
    <p><strong parentName="p">{`HIST 1207: Special Topics in Women’s History `}<em parentName="strong">{`4 credits`}</em></strong></p>
    <p><em parentName="p">{`Prerequisites: None`}</em></p>
    <p>{`This course provides an overview of women’s experiences in different historical periods and in
various geographical locations. Examines the roles assigned to women and at the selected experiences
of women. It studies the writings about and by women. Considers the lives of various historical
women who contributed to the disciplines of art, literature, philosophy, politics, and society.
Focus of the geographical area will vary.`}</p>
    <ol {...{
      "start": 5
    }}>
      <li parentName="ol">{`Artistic and Creative Expression`}</li>
    </ol>
    <p><strong parentName="p">{`ACE - ARTISTIC & CREATIVE EXPRESSION`}</strong></p>
    <p><em parentName="p">{`Prerequisites: None`}</em></p>
    <p>{`Courses in ACE are designed to advance the following skills:`}</p>
    <ul>
      <li parentName="ul">{`Develop competencies in creative thinking, artistic skills, and in the recognition of the
diversity of artistic expressions;`}</li>
      <li parentName="ul">{`Apply creative thinking and artistic practice to unique self or collective expressions;`}</li>
      <li parentName="ul">{`Design, create, and present or practice and perform works of art for an audience;`}</li>
      <li parentName="ul">{`Reflect or articulate on the creative process, product, performance, artistic skill, aesthetics,
or creative practice.`}</li>
    </ul>
    <p><strong parentName="p">{`ENGL 2305: Introduction to Creative Writing `}<em parentName="strong">{`4 credits`}</em></strong></p>
    <p><em parentName="p">{`Prerequisites: None`}</em></p>
    <p>{`Introduction to many forms of creative writing, including poetry, fiction, and drama writing. Study
of key terms and concepts in the writing process and practice in peer workshops.`}</p>
    <p><strong parentName="p">{`Digital Art and Storytelling `}<em parentName="strong">{`3 credits`}</em></strong></p>
    <p><em parentName="p">{`Prerequisites: TBD`}</em></p>
    <p>{`In this course, we will explore the many forms of storytelling through various forms of digital art
techniques such as scripting, storyboarding, typography, animation, and audio and cinematic
production. You will examine the world as it relates to oneself, communicate appealing stories to a
wider audience, and deliver visual artifacts and pitches. Students will create a digital portfolio
artifact and reflect on the creative process with peers.`}</p>
    <ol {...{
      "start": 6
    }}>
      <li parentName="ol">{`Science for Global Citizens`}</li>
    </ol>
    <p><strong parentName="p">{`SCI - SCIENCE `}</strong></p>
    <p><em parentName="p">{`Prerequisites: None`}</em></p>
    <p>{`Courses in SCI are designed to advance the following skills:`}</p>
    <ul>
      <li parentName="ul">{`Examine and apply the fundamental principles of the scientific discipline (true for each course)
in a manner that illustrates connections among science, technology, and society;`}</li>
      <li parentName="ul">{`Engage in the scientific method through laboratory and fieldwork to examine key elements of the
science and conduct independent exploration, using observational and direct measurement techniques
for primary data collection;`}</li>
      <li parentName="ul">{`Analyze, evaluate, manipulate, and interpret data to draw conclusions.`}</li>
    </ul>
    <p><strong parentName="p">{`PHSC 3210: Bay Area Rocks: Geology of Northern California `}<em parentName="strong">{`3 credits`}</em></strong></p>
    <p><em parentName="p">{`Corequisites: PHSC 3215 (Lab)`}</em></p>
    <p>{`This lecture class investigates the unique ecosystems of the Bay Area and Northern California. It
explores how the geology and physical environment of California have and continue to shape the way
people live here. Topics include natural disasters, resource use and allocation, water rights,
development limitations and energy generation.`}</p>
    <p><strong parentName="p">{`PHSC 3215: Bay Area Rocks: Geology of Northern California Lab `}<em parentName="strong">{`1 credit`}</em></strong></p>
    <p><em parentName="p">{`Corequisites: PHSC 3210 (Lecture)`}</em></p>
    <p>{`This is the lab component of PHSC 3215 (see course description above).`}</p>
    <p><strong parentName="p">{`PHYS 1000: Conceptual Physics `}<em parentName="strong">{`3 credits`}</em></strong></p>
    <p><em parentName="p">{`Corequisites: PHYS 1005 (Lab)`}</em></p>
    <p>{`An introductory physics class. Topics will include classical mechanics (motion), conservation of
energy, thermodynamics, electricity and magnetism, light, sound and wave properties`}</p>
    <p><strong parentName="p">{`PHYS 1000: Conceptual Physics Lab `}<em parentName="strong">{`1 credit`}</em></strong></p>
    <p><em parentName="p">{`Corequisites: PHYS 1000 (Lecture)`}</em></p>
    <p>{`This is the lab component of PHYS 1000 (see course description above).`}</p>
    <ol {...{
      "start": 7
    }}>
      <li parentName="ol">{`An Examined Life`}</li>
    </ol>
    <p><strong parentName="p">{`EL - EXAMINED LIFE`}</strong></p>
    <p><em parentName="p">{`Prerequisites: None`}</em></p>
    <p>{`Courses in EL are designed to advance the following skills:`}</p>
    <ul>
      <li parentName="ul">{`Comprehend theories and methods of the discipline under study and its modes of ethical inquiry;`}</li>
      <li parentName="ul">{`Analyze contemporary issues with attention to their ethical dimensions and the application of
theory to practice`}</li>
      <li parentName="ul">{`Demonstrate an awareness of differing values and ethical perspectives.`}</li>
    </ul>
    <p><strong parentName="p">{`PHIL 2110: Environmental Ethics `}<em parentName="strong">{`4 credits`}</em></strong></p>
    <p><em parentName="p">{`Prerequisites: None`}</em></p>
    <p>{`An investigation of philosophical perspectives on humanity’s relation to nature, combined with an
exploration of contemporary environmental issues and related political decision making.`}</p>
    <p><strong parentName="p">{`PHIL 3123: Ethical Being, Being Ethical `}<em parentName="strong">{`4 credits`}</em></strong></p>
    <p><em parentName="p">{`Prerequisites: None`}</em></p>
    <p>{`An introduction to ethical theory in Western philosophy followed by an investigation of a range of
contemporary ethical problems drawn from private life, public policy, law, medicine, and business.`}</p>
    <p><strong parentName="p">{`PHIL 3102: Global Business Ethics and Law`}</strong></p>
    <p><em parentName="p">{`Prerequisites: None`}</em></p>
    <p>{`The course examines the field of philosophical ethics and laws and facilitates students’ disciplined
reflections on ethical issues related to domestic and international business. The course covers
ethical methods as applied to business and the legal environment affecting business. Contemporary
ethical issues in business will be examined through case studies.`}</p>
    <p><strong parentName="p">{`PHIL 2107: Ethics and Society `}<em parentName="strong">{`4 credits`}</em></strong></p>
    <p><em parentName="p">{`Prerequisites: None`}</em></p>
    <p>{`This course will explore the ethical complexities of information and communication technology in
relation to humankind. By combining real-world inquiry with creative speculation, students will
probe everyday ethical dilemmas they face as digital consumers, creators, and coders, as well as
relevant policy. Students explore themes such as privacy, intellectual property, social justice,
free speech, artificial intelligence, and social media.`}</p>
    <ol {...{
      "start": 8
    }}>
      <li parentName="ol">{`Social Sciences: Understanding Human Behavior`}</li>
    </ol>
    <p><strong parentName="p">{`SSHB - SOCIAL SCIENCE`}</strong></p>
    <p><em parentName="p">{`Prerequisites: None`}</em></p>
    <p>{`Courses in SSHB are designed to advance the following skills:`}</p>
    <ul>
      <li parentName="ul">{`Effectively communicate an understanding of the research method(s) used by the discipline.`}</li>
      <li parentName="ul">{`Critically evaluate theory(s) in the discipline that have been put forth to explain some aspect of
human behavior.`}</li>
      <li parentName="ul">{`Reflect critically on individual identity and responsibilities as citizens of diverse communities.`}</li>
    </ul>
    <p><strong parentName="p">{`PSY 1100: Introduction to Psychology `}<em parentName="strong">{`4 credits`}</em></strong></p>
    <p><em parentName="p">{`Prerequisites: None`}</em></p>
    <p>{`Basic methods and concepts of psychology, focusing on research findings and theoretical viewpoints.
Topics include theories of personality, psychological development, personality disorders, social
psychology, cognition, motivation and emotion, perception and learning, biological and
socio-cultural bases of behavior.`}</p>
    <p><strong parentName="p">{`ECON 2010: Microeconomics and Personal Finance `}<em parentName="strong">{`4 credits`}</em></strong></p>
    <p><em parentName="p">{`Prerequisites: None`}</em></p>
    <p>{`This course constructs the beginning of a strong foundation of economics and personal finance in
order to empower students to function effectively as consumers, workers, investors, entrepreneurs,
and active citizens. It begins with a basic introduction to supply and demand and microeconomic
concepts. It then builds on economic concepts that will help students interpret the daily news,
understand the interdependencies of the world’s economies, and understand how markets operate within
the United States. On a personal level, students develop critical thinking skills about their own
economic choices and consumer decisions directly affect their likelihood of future economic success.`}</p>
    <p><strong parentName="p">{`ECON: Institutional Macroeconomics `}<em parentName="strong">{`3 credits`}</em></strong></p>
    <p><em parentName="p">{`Prerequisites: None`}</em></p>
    <p>{`This course focuses on understanding the ways to measure an economy by examining topics such as
economic growth, productivity, labor markets, monetary and fiscal policies, and international trade.
It introduces basic models of macroeconomics and illustrates principles with the experience of the
United States and other economies.`}</p>
    <ol {...{
      "start": 9
    }}>
      <li parentName="ol">{`Purpose and Meaning`}</li>
    </ol>
    <p><strong parentName="p">{`PM - PURPOSE & MEANING`}</strong></p>
    <p><em parentName="p">{`Prerequisites: None`}</em></p>
    <p>{`Courses in PM are designed to advance the following skills:`}</p>
    <ul>
      <li parentName="ul">{`Identify and contextualize key features of at least one religious and/or philosophical point of
view;`}</li>
      <li parentName="ul">{`Analyze the ethical implications of these key features for dealing with problems in contemporary
social life;`}</li>
      <li parentName="ul">{`Connect inquiry into those key features with their personal quest for meaning and well-being.`}</li>
    </ul>
    <p><strong parentName="p">{`PHIL 3125: Human Being, Being Human `}<em parentName="strong">{`4 credits`}</em></strong></p>
    <p><em parentName="p">{`Prerequisites: None`}</em></p>
    <p>{`Inquiry into the enduring questions of human nature including the meaning and purpose of human life,
the questions of its spiritual origin and destiny, its capacities for good and evil, the scope and
limits of its freedom, the nature of knowing, and the question of immortality, drawing upon a range
of Western thought. Particular attention is given to the tension between classical religious and
philosophical views and those stemming from modern human sciences such as psychology, sociology, and
sociobiology.`}</p>
    <p><strong parentName="p">{`RLGN 3003: Art and the Sacred `}<em parentName="strong">{`4 credits`}</em></strong></p>
    <p><em parentName="p">{`Prerequisites: None`}</em></p>
    <p>{`Analyzes ways that religions and the arts illuminate each other while providing insight into human
experiences, including alienation and injustice. May include community engagement.`}</p>
    <p><strong parentName="p">{`RLGN 3178: The World’s Religions `}<em parentName="strong">{`4 credits`}</em></strong></p>
    <p><em parentName="p">{`Prerequisites: None`}</em></p>
    <p>{`A study of humankind's ultimate and enduring questions­ the nature of reality and the meaning and
end of human life­ against the background of its multiform spiritual heritage. The course will
survey the world's religious traditions (Judaism, Christianity, Islam, Hinduism, Buddhism,
Confucianism, and Taoism), accenting both their commonalities and their distinctiveness.`}</p>
    <p><strong parentName="p">{`RLGN 3179: Myth, Symbol and Ritual `}<em parentName="strong">{`4 credits`}</em></strong></p>
    <p><em parentName="p">{`Prerequisites: None`}</em></p>
    <p>{`Using an interdisciplinary framework this course stresses that myth, symbol and ritual are of
crucial significance to all human societies, are intricately interdependent as phrenoma of religious
expression, and are vital to the study and to the understanding of religion and humankind. In this
course, we will engage in a cross-cultural examination of how diverse peoples establish their
religious worlds by narrating stories and symbolically acting out their deepest aspirations and
beliefs.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      